export var IMAGE_SCALING;
(function (IMAGE_SCALING) {
    IMAGE_SCALING[IMAGE_SCALING["FIT"] = 1] = "FIT";
    IMAGE_SCALING[IMAGE_SCALING["CROP"] = 2] = "CROP";
})(IMAGE_SCALING || (IMAGE_SCALING = {}));
